<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">View Service</h4>
</div>
<div class="modal-body">
    <json-viewer [json]='WipJson' [includeTextBox]='false'></json-viewer>
</div>